<template lang="html">
    <div class="iconsCell">
        <div v-if="hasNotes">
            <NotesHover :reservation="reservation" />
        </div>
        
        <div v-if="hasTransport" class="transport" tabindex="0"
             @mouseenter="openPopover" 
             @mouseleave="closePopover">
            <i class="ico ico-vehicle mr-0 fs-large" aria-hidden="true"></i>
            <div class="transport-popover" :class="{ above: isPopoverAbove }" v-show="isPopoverVisible">
                <div v-if="displayedTransfers.length">
                    <div v-for="(transfer, idx) in displayedTransfers" :key="idx" class="transport-card">
                        <div class="transport-title">{{ transportDirectionStatus(transfer.transportDirection) }}:</div>
                        <div class="transport-body">
                            <div class="transport-time">{{ transfer.schedule.timeShort }}</div>
                            <div class="transport-location">{{ transferRouteText(transfer) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotesHover from '../NotesHover.vue';
import hoverHelper from '@/utils/hoverHelper';
import { mapGetters } from 'vuex';
import TRANSPORT_DIRECTION from '@/enums/transportStatus';

export default {
    components: { NotesHover },
    props: {
        arguments:{
            required: true
        }
    },
    data() {
        return {
            isPopoverVisible: false,
            isPopoverAbove: false,
        };
    },
    computed: {
        ...mapGetters(['account']),
        transportDirectionEnum() { return TRANSPORT_DIRECTION; },
        reservation: function () {
            return this.arguments;
        },
        displayedTransport() {
            return this.reservation.transport;
        },
        displayedTransfers() {
            return (this.displayedTransport && this.displayedTransport.transfers) ? this.displayedTransport.transfers : [];
        },
        hasTransport: function () {
            return this.reservation.hasTransport;
        },
        hasNotes: function () {
            const reservation = this.reservation || {};
            return !!((reservation.note && reservation.note.trim()) || (reservation.internalNote && reservation.internalNote.trim()));
        },
    },
    methods: {
        ...hoverHelper,
        transportDirectionStatus(direction) {
            return direction == this.transportDirectionEnum.PICKUP ? 'Pickup' : 'Dropoff';
        },
        transferRouteText(transfer) {
            const eventLocation = this.reservation.event.location;
            const stopLocation = transfer.stop && transfer.stop.name ? transfer.stop.name : '';

            if (transfer.transportDirection == this.transportDirectionEnum.DROPOFF) {
                return eventLocation ? `${eventLocation} - ${stopLocation}` : stopLocation;
            }

            if (transfer.transportDirection == this.transportDirectionEnum.PICKUP) {
                return eventLocation ? `${stopLocation} - ${eventLocation}` : stopLocation;
            }

            return stopLocation;
        }
    }
}
</script>

<style lang="scss" scoped>

    .iconsCell{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
    }

    .iconsCell > * {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
    }

    .transport {
        position: relative;
        display: inline-flex;
        align-items: center;
        margin-left: 8px;
    }

    .transport-popover {
        position: absolute;
        top: 100%;
        left: auto;
        right: 0;
        margin-top: 1px;
        transform: translateX(12px);
        display: flex;
        gap: 12px;
        border: none;
        background: transparent;
        border-radius: 4px;
        padding: 6px;
        box-shadow: none;
        /* keep popover within viewport to avoid page horizontal growth; allow more width */
        max-width: calc(100vw - 120px);
        box-sizing: border-box;
        z-index: 60;
    }

    .transport-popover.above {
        top: auto;
        bottom: 100%;
        margin-top: 0;
        margin-bottom: 1px;
    }

    .transport-card {
        min-width: 180px;
        max-width: 360px;
        border: 1px solid #e6eaee;
        border-radius: 4px;
        padding: 8px;
        background: #fff;
        box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
        text-align: left;
    }

    .transport-title {
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 8px;
        color: #111827;
    }

    .transport-body {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-weight: 100;
        color: #4B536B;
    }

    .transport-time {
        font-size: 12px;
        color: #6b7280;
        margin-bottom: 8px;
    }

    .transport-location {
        font-size: 12px;
        line-height: 1.3;
        text-align: left;
        white-space: normal;
        word-break: break-word;
        max-width: 100%;
        color: #374151;
    }

</style>



// WEBPACK FOOTER //
// icons.vue?814dc280